import Spinner from 'components/Spinner';
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import NotFound from './pages/notFound';
import Offer from './pages/offer';
import Thanks from './pages/thanks';
import reportWebVitals from './reportWebVitals';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './assets/fonts/fonts.css';
import './index.css';

const LazyHome = lazy(() => import('./pages/home'));

const router = createBrowserRouter([
  {
    path: '/alectafastigheter',
    element: <LazyHome />,
    errorElement: <NotFound />,
  },
  {
    path: '/humlegarden',
    element: <LazyHome />,
    errorElement: <NotFound />,
  },
  {
    path: '/',
    element: <Offer />,
    errorElement: <NotFound />,
  },
  {
    path: '/thanks',
    element: <Thanks />,
    errorElement: <NotFound />,
  },
  {
    path: '*',
    element: <NotFound errorMessage="404" />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Suspense fallback={<Spinner />}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
